<template>
    <div class="comPoup">
        <el-dialog :visible.sync="dialogVisible" width="300px">
            <img :src="status?sucIcon:payIcon" alt="">
            <div class="com_main">
                <p>{{status?'报名成功':'您当前有进行中的订单，'}}</p>
                <p>{{status?'请耐心等待审核，审核通过进行支付。':'请完成后在继续购票！'}}</p>
            </div>
            <div class="com_footer">
                <el-button round @click="goDet">{{status?'返回详情':'再想想'}}</el-button>
                <el-button type="primary" round @click="close">查看订单</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: "comPoup",
        data(){
            return{
                payIcon:require('@/common/images/hd/payIcon.png'),
                sucIcon:require('@/common/images/hd/sucIcon.png'),
                dialogVisible:false,
                status:''
            }
        },
        methods:{
            open(status){
                this.status=status
                this.dialogVisible=true
            },
            //返回详情
            goDet(){
                this.dialogVisible=false
            },
            close(){
                this.dialogVisible=false
                this.$router.push({name: 'MyOrder',query:{kmctype:13}})
            }
        }
    }
</script>

<style lang="scss">
    .comPoup{
        .el-dialog{
            border-radius: 4px;
            text-align: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            margin-top: 0!important;
            img{
                margin: 0 auto 20px;
            }
            .el-dialog__body {
                padding: 0 20px 35px;
            }
        }
        .com_main{
            line-height: 25px;
        }
        .com_footer{
            margin-top: 30px;
            .el-button.is-round {
                border-radius: 20px;
                padding: 0 0;
                width: 100px;
                height: 30px;
            }
            .el-button{
                border: 1px solid #1464C8;
                color: #1464C8;
            }
            .el-button:focus, .el-button:hover{
                opacity: 0.8;
            }
            .el-button--primary{
                background-color: #1464C8;
                color: #fff;
            }
        }
    }
</style>